module.exports = __webpack_public_path__ + "static/media/notebooks.04026dd9.gif";